export default {"src":"/_next/static/media/0x028171bca77440897b824ca71d1c56cac55b68a3.b15825be.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};